<template>
    <div
        class="bg-white dark:bg-gray-700 shadow-sm rounded-lg border mb-5 w-full mx-auto"
        :class="[fullWidth === true ? 'max-w-7xl' : fullWidth || 'max-w-4xl']">
        <div
            v-if="header"
            class="px-4 py-5 sm:px-6">
            <div class="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div class="ml-4 mt-4">
                    <h3
                        class="text-base font-semibold leading-6"
                        :class="disabled ? 'text-gray-500' : 'text-gray-900' ">
                        {{ title }}
                    </h3>
                    <p
                        v-if="description"
                        class="mt-1 text-sm text-gray-500 dark:text-gray-300">
                        {{ description }}
                    </p>
                </div>
                <div class="flex gap-4 items-center ml-4 mt-4 flex-shrink-0 flex-wrap justify-end grow basis-0">
                    <slot name="actions" />
                    <Icon
                        v-if="collapsible && !disabled"
                        name="heroicons:chevron-down"
                        class="h-5 w-5 cursor-pointer text-gray-400 transition-transform duration-150"
                        :class="openProxy ? 'rotate-180' : ''"
                        @click="openProxy = !openProxy" />
                </div>
            </div>
        </div>
        <slot name="header" />
        <Transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-1">
            <div
                v-if="openProxy"
                class="border-gray-200 dark:border-gray-600"
                :class="[header ? 'border-t' : 'border-t-0', noPadding ? 'p-0' : 'p-5']">
                <slot />
            </div>
            <div
                v-else-if="$slots.collapsedBody"
                class="py-3 px-5 border-gray-200 dark:border-gray-600"
                :class="header ? 'border-t' : 'border-t-0'">
                <slot name="collapsedBody" />
            </div>
        </Transition>
    </div>
</template>

<script setup>
const open = ref(true)

const openProxy = computed({
    get: () => props.disabled ? false : open.value,
    set: (value) => {
        if (!props.disabled) {
            open.value = value
        }
    }
})

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: ''
    },
    description: {
        type: String,
        required: false,
        default: ''
    },
    collapsible: {
        type: Boolean,
        required: false,
        default: false
    },
    header: {
        type: Boolean,
        required: false,
        default: true
    },
    fullWidth: {
        type: [Boolean, String],
        required: false,
        default: false
    },
    noPadding: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false
    }
})
</script>